/* @flow weak */
import * as React from 'react';
import enumerate from 'lib/enumerate';
import Button from 'components/Button.jsx';
import DialogContent from 'components/DialogContent.jsx';
import Image from 'components/Image.jsx';
import SetupRosteredClassesList from './SetupRosteredClassesList.jsx';
import Text from 'components/Text.jsx';
import { pollAndRefresh } from 'setup/utils/rosterPoll';
import trackView from 'lib/trackView';

import type { ProposedGroup } from './SetupRosterChoose';

import './styles/SetupRosterPoll.scss';

export const STATUS = enumerate(['loading', 'complete']);

type State = {
  status: string,
};

type Props = {
  statusEndpoint: string,
  proposedGroups: Array<ProposedGroup>,
};

type ContentProps = {
  groupsList: any,
};

const title =
  'Your classes and participants are being imported to Remind. This will only take a few moments.';
const image = require('assets/images/roster-importing-header.png');

export const SetupRosterPollLoading = (props: ContentProps) => (
  <DialogContent
    size="small"
    className="SetupRosterLoading-header"
    title={title}
    subtext={props.groupsList}
    image={image}>
    <Image
      src={require('assets/images/roster-spinner.png')}
      className="SetupRosterLoading-spinner"
    />
    <Text className="SetupRosterLoading-spinnerText" color="brand">
      Importing...
    </Text>
    <Button className="SetupRosterLoading-submit" disabled>
      Continue
    </Button>
  </DialogContent>
);

export const SetupRosterPollComplete = (props: ContentProps) => (
  <DialogContent
    size="small"
    className="SetupRosterLoading-header"
    title={title}
    subtext={props.groupsList}
    image={image}>
    <Image src={require('assets/images/roster-done.png')} className="SetupRosterLoading-done" />
    <Text className="SetupRosterLoading-spinnerText" color="shamrock">
      All done!
    </Text>
    <Button className="SetupRosterLoading-submit" to="/landing">
      Continue
    </Button>
  </DialogContent>
);

export class SetupRosterPoll extends React.Component<Props, State> {
  state: State = {
    status: STATUS.loading,
  };

  componentDidMount() {
    const markComplete = () => this.setState({ status: STATUS.complete });
    pollAndRefresh(this.props.statusEndpoint)
      .then(markComplete)
      .catch(markComplete);
  }

  groupsList() {
    return <SetupRosteredClassesList proposedGroups={this.props.proposedGroups} />;
  }

  render() {
    return (
      <div className="SetupRosterPoll">
        {this.state.status === STATUS.loading ? (
          <SetupRosterPollLoading groupsList={this.groupsList()} />
        ) : (
          <SetupRosterPollComplete groupsList={this.groupsList()} />
        )}
      </div>
    );
  }
}

export default trackView(SetupRosterPoll, 'sis_roster_poll');
